import React, { useState } from "react";
import styles from "./SupervisorOrderHistory.module.css";
import StepsComponent from "../../../../../../components/StepsComponent/StepsComponent";
import SubmitButton from "../../../../../../components/submitButton/SubmitButton";
import TextComponent from "../../../../../../components/textComponent/TextComponent";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";



const OrderHistoryComponent = () => {
    const navigate = useNavigate();

    const columns = [
        {
            title: "Order ID",
            dataIndex: "OrderID",
            key: "OrderID",
        },
        
        {
            title: "Order By",
            key: "OrderBy",
            dataIndex: "OrderBy",
        },
        {
            title: "Order Date",
            dataIndex: "OrderDate",
            key: "OrderDate",
        },
        {
            title: "Fulfillment Status",
            key: "FulfillmentStatus",
            dataIndex: "FulfillmentStatus",
        },
         {
            title: "Due Date",
            dataIndex: "DueDate",
            key: "DueDate",
        },
        {
            title: "",
            key: "action",
            dataIndex: "Button",
            render: (text, record) => record.Button,
        },

    ];

    const data = [
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            DueDate:"Aug 13, 2025 ",
            OrderBy: "Alex Buckmaster",
            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                    onClick={() => navigate("/Training/SupervisorProductJourney")}

                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            OrderBy: "Alex Buckmaster",
            DueDate:"Aug 13, 2025 ",
            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                // onClick={handleSubmit}
                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            OrderBy: "Alex Buckmaster",
            DueDate:"Aug 13, 2025 ",
            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                // onClick={handleSubmit}
                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            OrderBy: "Alex Buckmaster",
            DueDate:"Aug 13, 2025 ",

            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                // onClick={handleSubmit}
                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            OrderBy: "Alex Buckmaster",
            FulfillmentStatus: "Delivered",
            DueDate:"Aug 13, 2025 ",

            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                // onClick={handleSubmit}
                />
        },

    ];

    return (
        <div className={styles.mainCont}>

            <div className={styles.TableDiv}>
                <Table
                    scroll={{ x: true }}
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    rowKey="No"
                />
            </div>

        </div>
    );
};

export default OrderHistoryComponent;
